import { render, staticRenderFns } from "./LogoSquare.vue?vue&type=template&id=5edc8ed4"
import script from "./LogoSquare.vue?vue&type=script&lang=js"
export * from "./LogoSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports